import ContactInfo from "../ui/ContactComponet";
import { Container, Row } from "../ui/Containers";
import WorkComponent from "../ui/workComponent";
import { sideProjects } from "../../hooks/data";
import { styled } from "styled-components";
import AnimatedText from "../ui/Animation/AnimatedText";
import PageTransition from "../../utils/TransitionPage";
import { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { useCommonConfig } from "../../hooks/useCommonConfig";

const AlignWorkDiv = styled.div`
  margin-top: 2rem;
  @media (max-width: 576px) {
    margin-top: 5rem;
  }
`;

function Work() {
  const [showTransition, setShowTransition] = useState(true);
  const { isProjectLoading, fetchedProjects, FetchLoader } = useAuth();
  const { isDark } = useCommonConfig();

  const phrase =
    "Building cutting-edge digital products that redefine user experiences.";
  return (
    <>
      {showTransition && (
        <PageTransition onFinish={() => setShowTransition(false)} />
      )}

      {!showTransition && (
        <Container>
          <Row>
            <AlignWorkDiv className="col-*-*">
              <AnimatedText
                $animTextMargin="0 0 4rem 0"
                text={phrase}
                className="heavyText"
              />

              {isProjectLoading ? (
                FetchLoader
              ) : (
                <WorkComponent
                  projects={fetchedProjects}
                  sideProjects={sideProjects}
                  $isDark={isDark}
                />
              )}
            </AlignWorkDiv>
          </Row>
          <ContactInfo />
        </Container>
      )}
    </>
  );
}

export default Work;
